import { render, staticRenderFns } from "./CanalLivezilla.vue?vue&type=template&id=46fd9b69&scoped=true"
import script from "./CanalLivezilla.vue?vue&type=script&lang=js"
export * from "./CanalLivezilla.vue?vue&type=script&lang=js"
import style0 from "./CanalLivezilla.vue?vue&type=style&index=0&id=46fd9b69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fd9b69",
  null
  
)

export default component.exports